import Api from '../Api'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  checkUserSession,
  getUserData
} from '../actions/user-session'

import { setAlert } from '../actions/alerts'

import Layout from '../components/common/layout'
import Login from './login'

const UserSession = (WrappedComponent, props) => {
  class Authorize extends Component {
    constructor(props) {
      super(props)

      this.state = {
        refreshTimeout: undefined
      }
    }

    componentWillMount() {
      const { userSession } = this.props

      if (userSession.loggedIn === undefined) this.props.checkUserSession()
      if (userSession.loggedIn) this.setUserSessionRefresh()
      if (userSession.loggedIn && !userSession.user) this.props.getUserData()
    }

    componentWillReceiveProps(nextProps) {
      const { userSession } = nextProps
      const { refreshTimeout } = this.state

      if (userSession.loggedIn && refreshTimeout === undefined) this.setUserSessionRefresh()
      if (userSession.loggedIn && !userSession.user) this.props.getUserData()
    }

    componentWillUnmount() {
      const { refreshTimeout } = this.state

      if (refreshTimeout) clearTimeout(refreshTimeout)
    }

    setUserSessionRefresh() {
      const refreshPeriod = Api.getTokenRefreshPeriod()

      const timeout = () => {
        Api.refresh()
        .then(success => this.setUserSessionRefresh())
        .catch(error => {
          this.props.setAlert('We could not refresh your session. Please log in again.', null, 'error')
          Api.logout()
        })
      }

      if (refreshPeriod) {
        const refreshTimeout = setTimeout(timeout, refreshPeriod)

        this.setState({refreshTimeout})
      } else {
        this.setState({refreshTimeout: undefined})
      }
    }

    renderDecoratedComponent() {
      const { match, location, history, userSession } = this.props

      return (
        <WrappedComponent
          match={match}
          location={location}
          history={history}
          userSession={userSession} />
      )
    }

    render() {
      const { location, userSession } = this.props
      const { pathname } = location

      const userAuthorized = userSession.loggedIn

      const publicComponents = pathname.indexOf('/rider') === 0 || pathname.indexOf('/login') === 0 || pathname.indexOf('/register') === 0

      return (
        <Layout userSession={userSession} pathname={pathname}>
          {
            userAuthorized === true || publicComponents
            ? this.renderDecoratedComponent()
            : <Login />
          }
        </Layout>
      )
    }
  }

  Authorize.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    userSession: PropTypes.object,
    checkUserSession: PropTypes.func,
    getUserData: PropTypes.func,
    setAlert: PropTypes.func
  }

  Authorize.defaultProps = {
    match: {},
    location: {},
    history: {},
    userSession: {},
    checkUserSession: function() {},
    getUserData: function() {},
    setAlert: function() {}
  }

  const mapStateToProps = (state) => {
    return {
      userSession: state.userSession
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
      checkUserSession,
      getUserData,
      setAlert
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(Authorize)
}

export default UserSession



// WEBPACK FOOTER //
// ./src/containers/user-session.js